import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AgentAvatar from '../AgentAvatar/AgentAvatar';
import Button from '@material-ui/core/Button';
import PersonOutline from '@material-ui/icons/PersonOutline';
import EmailOutline from '@material-ui/icons/MailOutline';
import styles from './AgencyCards_mui.scss';
import Ratings from '../RateMyAgent/Ratings';
import TooltipText from '../../constants/TooltipText';

const ListingCountLabel = (count, url, label) => {
  return (
    count > 0 ?
      <Link className="d-flex" to={url}>
        <div className="d-flex flex-column align-items-md-center justify-content-md-center">
          <div><Typography variant="subtitle1">{count}</Typography></div>
          <div><Typography variant="subtitle2" className="text-nowrap">{label}</Typography></div>
        </div>
      </Link>
      : null
  );
};

const AgentCard = (props) => {
  const {
    agent,
    rmaAgentProfiles,
  } = props;
  const { dynamicFields, logoURL, headshot, fullName, referrer, agentURL, uuid } = agent;
  const agencyName = agent?.expandedLinks?.agency?.name || 'No Agency';
  const rmaData = rmaAgentProfiles?.data?.[uuid];
  const {
    overallStars,
    reviewCount,
    branding: {
      photo: rmaPhoto,
    } = {},
    agentProfileTrixelImgUrl,
  } = rmaData || {};
  const agentHeadshot = headshot?.includes('headshot-placeholder-mui.svg') && rmaPhoto ? rmaPhoto : headshot;

  let logoSRC = logoURL;
  if (logoSRC && logoSRC.match(/agency-logo-placeholder/)) logoSRC = null;
  const {currentRecentSalesCount, currentRentalListingCount, currentSaleListingCount} = dynamicFields;
  let bgColor = undefined;
  if (agent?.expandedLinks?.agency?.bannerHex) bgColor = `${agent.expandedLinks.agency.bannerHex.indexOf('#') === 0 ? '' : '#'}${agent.expandedLinks.agency.bannerHex}`;

  const dests = ['agent', 'contact-form', 'sold', 'for-rent', 'for-sale', 'reviews-section'];
  let urls = {};
  dests.map((destination) => {
    urls[destination] = {pathname: '/'};
    if (agentURL) {
      urls[destination].pathname = agentURL;
      if (destination !== 'agent') urls[destination].hash = destination;
    }
    if (referrer) urls[destination].state = {referrer: referrer};
  });

  return (
    <div className={styles.agentCardMui}>
      {agentProfileTrixelImgUrl && <img loading="lazy" alt="" src={agentProfileTrixelImgUrl} />}
      <Paper className="mb-3 position-relative">
        <div className={styles.body} style={{'--customBG': bgColor}}>

          <div className="d-flex flex-column flex-md-row align-items-md-center w-100">
            <div className={`d-flex d-md-none justify-content-end ${styles.mobileLogo}`}>
              <Link to={urls['agent']}>
                <img src={logoSRC} onError={({currentTarget}) => {currentTarget.onerror = null; currentTarget.style.display = 'none';}} />
              </Link>
            </div>

            <div className="d-flex flex-grow-1">
              <div className={styles.avatarContainer}>
                <Link to={urls['agent']} className="display-block">
                  <AgentAvatar size="xl" avatarUrl={agentHeadshot} />
                </Link>
                <div className={styles.rmaAgentRatingContainer}>
                  <Ratings
                    id="agent-search-card"
                    overallStars={overallStars}
                    reviewCount={reviewCount}
                    reviewsUrl={urls['reviews-section']}
                    tooltipText={TooltipText.RMA_AGENT_DATA_DISCLAIMER}
                  />
                </div>
              </div>

              <div className="d-flex flex-grow-1 pl-4 flex-column flex-md-row">
                <div className="d-flex flex-grow-1">
                  <div className="d-flex flex-column justify-content-center h-100">
                    <div className={styles.h2}><Typography variant="h2"><Link to={urls['agent']}>{fullName}</Link></Typography></div>
                    <div><Typography variant="caption">{agencyName && <div>{agencyName}</div>}</Typography></div>
                    {logoSRC && <Link to={urls['agent']} className={`d-none d-md-block ${styles.agentLogo}`}><img src={logoSRC} onError={({currentTarget}) => {currentTarget.onerror = null; currentTarget.parentElement.style = 'display: none !important';}} /></Link>}
                  </div>
                </div>
                <div className="d-flex">
                  <div id="listing-counts" className={`flex-grow-1 d-flex justify-content-md-end ${styles.listingCounts}`}>
                    {ListingCountLabel(currentSaleListingCount, urls['for-sale'], 'For Sale')}
                    {ListingCountLabel(currentRentalListingCount, urls['for-rent'], 'For Rent')}
                    {ListingCountLabel(currentRecentSalesCount, urls['sold'], 'Sold')}
                  </div>
                </div>
              </div>
            </div>

            <div className={`d-flex flex-md-column justify-content-between h-100 ${styles.cardButtonContainer}`}>
              <div className="flex-grow-1"><Button color="secondary" variant="outlined" component={Link} to={urls['agent']} className="w-100" startIcon={<PersonOutline fontSize="small" className="d-none d-lg-inline" />}><span className="d-md-none d-lg-inline">View&nbsp;</span>Profile</Button></div>
              <div className="flex-grow-1">{agentURL && <Button color="primary" variant="contained" component={Link} to={urls['contact-form']} className="w-100" startIcon={<EmailOutline fontSize="small" className="d-none d-lg-inline" />}>Contact<span className="d-md-none d-lg-inline">&nbsp;Agent</span></Button>}</div>
            </div>
          </div>
        </div>
      </Paper>
    </div>
  );
};

AgentCard.propTypes = {
  agent: PropTypes.object,
  rmaAgentProfiles: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    rmaAgentProfiles: state.rmaAgentProfiles,
  };
};

export default connect(mapStateToProps)(AgentCard);
